import { COMPANY_INFO, customerServicePhone } from '../config/constants';

// Phone formatting functions
export const PHONE_FORMATS = {
  // Format like (877) 868-3800
  display: (phone) => `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`,
  // Format like 877-868-3800 for tel: links
  tel: (phone) => `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6)}`,
  // Raw format like 8778683800
  raw: (phone) => phone
};

// Address formatting functions with JSX support
export const ADDRESS_FORMATS = {
  // Multi-line format with line breaks and phone (for corporate headquarters, contact info)
  multiLine: (address) => (
    <>
      {address.street}
      <br />
      {address.city}, {address.state} {address.zipCode}
      <br />
      Tel: {address.phone}
    </>
  ),

  // Single line format
  singleLine: (address) =>
    `${address.street}, ${address.city}, ${address.state} ${address.zipCode}`,

  // Mailing format without phone
  mailingFormat: (address) => (
    <>
      {address.street}<br />
      {address.city}, {address.state} {address.zipCode}
    </>
  ),

  // Contact format with phone
  contactFormat: (address) => (
    <>
      {address.street}<br />
      {address.city}, {address.state} {address.zipCode}<br />
      Phone: {address.phone}
    </>
  )
};

// Utility function to get formatted address
export const getFormattedAddress = (format) => {
  return ADDRESS_FORMATS[format](COMPANY_INFO.address);
};

// Utility function to get formatted customer service phone
export const getFormattedPhone = (format = 'display') => {
  return PHONE_FORMATS[format](customerServicePhone);
};

// Export company info for convenience
export { COMPANY_INFO, customerServicePhone } from '../config/constants';
